import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlPayment} from '../getPayment.api';
import {Payment} from '../../../graphql/payments.datatypes';

interface DeletePaymentInput {
    id: number
}

interface DeletePaymentData {
    deletePayment: Payment
}

export const DELETE_PAYMENT_MUTATION = gql`
    mutation deletePayment($id: Int!) {
        deletePayment(id: $id) {
            ${gqlPayment}
        }
    }
`;

export const deletePayment = () => useMutation<DeletePaymentData, DeletePaymentInput>(
    DELETE_PAYMENT_MUTATION,
    {
        update: updateCacheByType('Payment'),
    }
);

export default deletePayment;